<template>
  <BaseList listSubtitulo="Lista das etapas do modelo" :data="dados.results" :columns="columns"
            :globalFilterFields="columns"
            :totalRecords="dados.count" @update:pagination="loadDataLazy">
    <template v-slot:incluirCadastro>
      <button v-if="isStaff" id="id_incluir" class="btn btn-primary btn-sm font-bold modalIncluir"
              @click="abrirModal('cadastro')"
              title="Incluir novo registro.">
        <i class="fa fa-plus"></i> INCLUIR
      </button>
    </template>

    <template #actions="{ data }">
      <div class="dropdown text-center">
        <button
            class="btn btn-info btn-sm dropdown-toggle font-bold"
            type="button"
            data-toggle="dropdown" data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
        >
          OPÇÕES
        </button>
        <ul class="dropdown-menu p-2 border-0 shadow-sm rounded-3">
          <li>
            <button class="btn btn-outline-primary font-bold mb-1 w-100 rounded"
                    @click="abrirModal('cadastroModeloMaterial', data.id, data.key, `${data.modelo_exibicao} - ${data.etapa_exibicao}`)">
              <i class="fa fa-plus"></i> MATERIAIS DA ETAPA
            </button>
          </li>
          <li>
            <button class="btn btn-outline-custom-orange font-bold mb-1 w-100 rounded"
                    @click="abrirModal('editar', data.id, data.key)">
              <i class="fa fa-edit"></i> Atualizar
            </button>
          </li>
          <li>
            <button class="btn btn-outline-danger font-bold mb-1 w-100 rounded"
                    @click="deletarItem(data.key, data.id, `${data.modelo_exibicao} - ${data.etapa_exibicao}`)">
              <i class="fa fa-trash"></i> Excluir
            </button>
          </li>
        </ul>
      </div>
    </template>
  </BaseList>
  <CadastrarModeloEtapas
      v-if="modalAtivo === 'cadastro'"
      :idModal="'cadastarModeloEtapa'"
      :modeloId="Number(modeloId)"
      :modeloDescricao="modeloDescricao"
      @fechar="fecharModal"
      @atualizarLista="atualizarListaDados"
  />
  <EditarModeloEtapa
      v-if="modalAtivo === 'editar'"
      :idModal="'editarModeloEtapa'"
      @fechar="fecharModal"
      @atualizarDados="atualizarDados"
      :itemKey="itemKeySelect"
  />
  <CadastrarModeloMaterial
      v-if="modalAtivo === 'cadastroModeloMaterial'"
      :idModal="'cadastarModeloMaterial'"
      :modeloEtapaId="itemSelect"
      :modeloEtapa="modeloEtapa"
      @fechar="fecharModal"
      @atualizarLista="atualizarListaDados"
  />
</template>

<script>
import BaseList from "@/components/base/BaseList.vue";
import CadastrarModeloEtapas from "./CadastrarModeloEtapas.vue";
import EditarModeloEtapa from "./EditarModeloEtapa.vue";
import CadastrarModeloMaterial from "./materiais_modelo/CadastrarModeloMaterial.vue";
import {apiRequest, alertDelete} from "../../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "ListaModeloEtapas",
  components: {
    BaseList,
    CadastrarModeloEtapas,
    EditarModeloEtapa,
    CadastrarModeloMaterial,
  },
  data() {
    return {
      dados: {
        results: [],
        count: 0,
      },
      pagination: {
        page: 1,
        page_size: 10,
      },
      erro: null,
      modalAtivo: null,
      itemSelect: null,
      itemKeySelect: null,
      modeloEtapa: null,
      isStaff: localStorage.getItem('admin_isStaff'),
      modeloId: this.$route.query.modeloId,
      modeloDescricao: this.$route.query.modeloDescricao,
      columns: [
        {field: 'id', header: 'ID', align: 'text-right',},
        {field: 'etapa_exibicao', header: 'ETAPA',},
        {field: 'modelo_exibicao', header: 'MODELOS',},
        {field: 'data_inicio', header: 'DATA INÍCIO', align: 'text-center',},
        {field: 'data_termino_previsao', header: 'DATA PREVISÃO DE TÉRMINO', align: 'text-center',},
        {field: 'data_termino', header: 'DATA TÉRMINO', align: 'text-center',},
        {field: 'observacao', header: 'OBSERVAÇÃO',},
        {field: 'orcamento_etapa', header: 'ORÇAMENTO ETAPA(R$)', align: 'text-right'},
      ]
    };
  },
  methods: {
    atualizarListaDados(novoDado) {
      this.loadDataLazy({page: 1, page_size: this.pagination.page_size});
    },
    atualizarDados(dadoAtualizado) {
      const index = this.dados.results.findIndex(dado => dado.id === dadoAtualizado.id);
      if (index !== -1) {
        this.dados.results[index] = dadoAtualizado;
      }
    },
    abrirModal(tipo, id = null, key = null, modeloEtapa = null) {
      this.modalAtivo = tipo;
      if (key) {
        this.itemKeySelect = key;
      }
      if (id) {
        this.itemSelect = id;
      }
      if (modeloEtapa) {
        this.modeloEtapa = modeloEtapa
      }
    },
    fecharModal() {
      this.modalAtivo = null;
    },
    deletarItem(itemkey, itemId, itemNome) {
      let url = apiUrl.modelos.etapaRetrieveUpdateDestroy(itemkey);
      alertDelete(itemkey, url, 'Você deseja deletar o registro?', `ID: ${itemId} | ${itemNome}`, itemkey, () => {
        this.loadDataLazy(this.pagination);
      });
    },
    async loadDataLazy(paginationParams = this.pagination) {
      this.pagination = {
        page: paginationParams.page,
        page_size: paginationParams.page_size,
      };

      const params = {
        page: this.pagination.page,
        page_size: this.pagination.page_size,
      };

      if (paginationParams.search) {
        params.search = paginationParams.search;
      }

      const resultado = await apiRequest("GET", apiUrl.modelos.etapaCreateList(this.modeloId), params);

      if (resultado.success) {
        this.dados.results = resultado.data.results || [];
        this.dados.count = resultado.data.count || 0;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getDados() {
      await this.loadDataLazy();
    },
  },
  mounted() {
    this.getDados();
  },
};
</script>
